
require('./vendor/modernizr.custom.js');

window.jQuery = window.$ = require('jquery');
window.Headroom = require('headroom.js');
window.ko = require('knockout');
window.ko.mapping = require('knockout.mapping');
window.moment = require('moment');
require('jquery.cookie');

require('./components/jquery.history.js');

//vendor
require('velocity-animate');
require('slick-carousel');
require('./components/utils');
require('devbridge-autocomplete');


// WEBPACK FOOTER //
// ./assets/Main/public/js/libs.js